import { Icon } from '#/components/Icon/Icon';

import {
  LocationRadiusSelectChevronHolder,
  LocationRadiusSelectHolder,
  LocationRadiusSelectLeftIconHolder,
  LocationRadiusSelectStyled,
} from './LocationRadiusSelect.styled';

export type LocationRadiusSelectHandle =
  | {
      type: 'controlled';
      radius: string;
      onChange: (newRadius: string) => void;
    }
  | {
      type: 'uncontrolled';
      radius: string;
    };

type Props = {
  handle: LocationRadiusSelectHandle;
  options: { label: string; value: string }[];
  disabled: boolean;
  qaId: string;
  fullWidth?: boolean;
};

export function LocationRadiusSelect({
  handle,
  options,
  disabled,
  qaId,
  fullWidth,
}: Props) {
  return (
    <LocationRadiusSelectHolder>
      <LocationRadiusSelectLeftIconHolder>
        <Icon name="bulls-eye" size={24} />
      </LocationRadiusSelectLeftIconHolder>

      <LocationRadiusSelectStyled
        key={
          handle.type === 'uncontrolled'
            ? `uncontrolled-${handle.radius}`
            : 'controlled'
        }
        name="radius"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...(handle.type === 'controlled'
          ? {
              value: handle.radius,
              onChange: (event) => {
                if (handle.type === 'controlled')
                  handle.onChange(event.target.value);
              },
            }
          : { defaultValue: handle.radius })}
        disabled={disabled}
        $fullWidth={Boolean(fullWidth)}
        data-qa-id={qaId}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </LocationRadiusSelectStyled>

      <LocationRadiusSelectChevronHolder>
        <Icon name="chevron-down" size={16} />
      </LocationRadiusSelectChevronHolder>
    </LocationRadiusSelectHolder>
  );
}
